export default{
  "login": "NumanAnees",
  "id": 67089723,
  "node_id": "MDQ6VXNlcjY3MDg5NzIz",
  "avatar_url": "https://avatars.githubusercontent.com/u/67089723?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/NumanAnees",
  "html_url": "https://github.com/NumanAnees",
  "followers_url": "https://api.github.com/users/NumanAnees/followers",
  "following_url": "https://api.github.com/users/NumanAnees/following{/other_user}",
  "gists_url": "https://api.github.com/users/NumanAnees/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/NumanAnees/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/NumanAnees/subscriptions",
  "organizations_url": "https://api.github.com/users/NumanAnees/orgs",
  "repos_url": "https://api.github.com/users/NumanAnees/repos",
  "events_url": "https://api.github.com/users/NumanAnees/events{/privacy}",
  "received_events_url": "https://api.github.com/users/NumanAnees/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Numan Anees",
  "company": null,
  "blog": "",
  "location": "Lahore",
  "email": null,
  "hireable": null,
  "bio": "A self taught software engineer. Passionate about coding and enjoy teaching coding.",
  "twitter_username": null,
  "public_repos": 14,
  "public_gists": 1,
  "followers": 23,
  "following": 27,
  "created_at": "2020-06-18T05:30:42Z",
  "updated_at": "2021-05-10T20:07:20Z"
}
